import { keyBy } from 'lodash';

import {
  GET_RATE_OPTIONS,
  GET_RATE_OPTIONS_FAILED,
  GET_RATE_OPTIONS_SUCCESS,
} from "../actions/rateOptionManagement.action";

const INITIAL_STATE = {
  rateOptions: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function rateOptionReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_RATE_OPTIONS:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_RATE_OPTIONS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        rateOptions: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_RATE_OPTIONS_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
